// Helper único de download no browser: cria um Blob (se ainda não for
// um), gera um object URL temporário, dispara o clique num <a> oculto e
// liberta o URL a seguir. Substitui a repetição de
// URL.createObjectURL + <a>.download + click espalhada pelos vários
// pontos de exportação (georref, placement, edit, CSV do IDS e do BoQ).
//
// Não mostra toast nem confirma nada: quem chama decide a mensagem, para
// manter as confirmações inline ricas onde já existem.

export function downloadBlob(
  data: Blob | BlobPart,
  filename: string,
  mimeType = 'application/octet-stream',
): void {
  const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
